

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

/**
 * Composant de vignette simple du dashboard.
 */
@Component
export default class Label extends Vue {
	/** Propriétés */
	@Prop()
	title!: string;
	@Prop()
	link!: string;
	@Prop()
	linkLabel!: string;
	@Prop()
	apiCall!: () => any;
	@Prop()
	resultDetailTransform: ((x: any) => any) | undefined;

	/** Attributs */
	result: any | null = null;
	isFetching = false;

	get resultLength() {
		return this.result.length;
	}

	/** Méthodes */
	async created() {
		this.isFetching = true;
		try {
			this.result = await this.apiCall();
		}
		catch (ex) {
		}
		this.isFetching = false;
	}
}
